/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import cn from 'classnames';
import Image from 'next/legacy/image';
import { useRef, useState } from 'react';
import Slider from 'react-slick';
import { VehicleImageType } from 'src/modules/newCars/types';
import s from './Header.module.scss';

export const Header = ({
  content,
  images,
  showBottom = true,
}: {
  content: any;
  images: VehicleImageType;
  showBottom?: boolean;
}) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const sliderRef = useRef<any>();

  function handleClick(idx) {
    setActiveSlide(idx);
    sliderRef?.current?.slickGoTo(idx);
  }

  function handleImageClick(item) {
    // console.log(item);
  }

  console.log("images",images)
  
  return (
    <div className={s.root}>
      <div
        className={cn(s.cars_display, {
          [s.long_display]: showBottom && !images?.exterior?.length,
        })}
      >
        {images?.exterior?.length ? (
          <Slider
            speed={500}
            slidesToShow={1}
            className="slick_generic_slider image_view_slider"
            slidesToScroll={1}
            afterChange={(current) => {
              const ele = document.getElementById(`img-${current}`);
              if (ele)
                ele.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest',
                  // inline: 'center',
                });
              setActiveSlide(current);
            }}
            centerPadding="0px"
            ref={sliderRef}
            initialSlide={activeSlide}
            infinite={false}
            dots={true}
          >
            {images?.exterior?.map((item) => (
              <figure
                className={s.image_wrapper}
                key={item?.url ?? ""}
                onClick={() => handleImageClick(item)}
              >
                <Image src={item?.url ?? ""} alt={`${content?.modelSeoData?.brandSlug}-${content?.modelSeoData?.modelSlug}-image`} height={560} width={1000} layout='responsive' objectFit='cover' priority/>
               </figure> 
            ))}
          </Slider>
        ) : (
          <figure
            className={s.image_wrapper}
            key={images?.frontImage}
            onClick={() => handleImageClick(images?.frontImage)}
          >
            <img src={images?.frontImage} alt={`${content?.modelSeoData?.brandSlug}-${content?.modelSeoData?.modelSlug}-image`} />
          </figure>
        )}
      </div>
      {showBottom && !!images?.exterior?.length && (
        <div className={s.scroll}>
          {images?.exterior?.map((item, idx) => (
            <div
              className={`${idx === activeSlide
                ? `${s.btn_active} cmn_touchable_area`
                : 'cmn_touchable_area'
                }`}
              key={item.url}
              onClick={() => handleClick(idx)}
              id={`img-${idx}`}
            >
              <img src={item.url} alt={`${content?.modelSeoData?.brandSlug}-${content?.modelSeoData?.modelSlug}-image`} />
              {idx === activeSlide && <div className={s.overlay} />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
